// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EstimatedTotal_stepTitle__S9FQl {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 25px;
  text-align: center;
}

.EstimatedTotal_formContent__M2f5P {
  width: 100%;
}

.EstimatedTotal_accordionGroup__gubYy {
  width: 100%;
  margin-bottom: 20px;
}

.EstimatedTotal_lineItemList__VtVgD {
  list-style: none;
  padding: 0;
  margin: 0;
}

.EstimatedTotal_lineItem__WSssA {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.EstimatedTotal_lineItem__WSssA:last-child {
  border-bottom: none;
}

.EstimatedTotal_lineItemName__\\+KmyV {
  font-weight: 500;
  color: #333;
}

.EstimatedTotal_lineItemDetails__LXvJF {
  font-weight: 400;
  color: #555;
  text-align: right;
}

.EstimatedTotal_noLineItems__FoBq9 {
  padding: 20px 0;
  text-align: center;
  color: #777;
}

.EstimatedTotal_totalRow__xAl94 {
  padding-top: 15px;
  margin-top: 10px;
}

.EstimatedTotal_totalRow__xAl94 .EstimatedTotal_lineItemName__\\+KmyV,
.EstimatedTotal_totalRow__xAl94 .EstimatedTotal_lineItemDetails__LXvJF {
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--primary-dark-blue);
}

.EstimatedTotal_instructionText__KWObW {
  text-align: center;
  font-size: 1rem;
  color: #444;
  margin-top: 30px;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/EstimatedTotal/EstimatedTotal.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.formContent {\n  width: 100%;\n}\n\n.accordionGroup {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.lineItemList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.lineItem {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.lineItem:last-child {\n  border-bottom: none;\n}\n\n.lineItemName {\n  font-weight: 500;\n  color: #333;\n}\n\n.lineItemDetails {\n  font-weight: 400;\n  color: #555;\n  text-align: right;\n}\n\n.noLineItems {\n  padding: 20px 0;\n  text-align: center;\n  color: #777;\n}\n\n.totalRow {\n  padding-top: 15px;\n  margin-top: 10px;\n}\n\n.totalRow .lineItemName,\n.totalRow .lineItemDetails {\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: var(--primary-dark-blue);\n}\n\n.instructionText {\n  text-align: center;\n  font-size: 1rem;\n  color: #444;\n  margin-top: 30px;\n  line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `EstimatedTotal_stepTitle__S9FQl`,
	"formContent": `EstimatedTotal_formContent__M2f5P`,
	"accordionGroup": `EstimatedTotal_accordionGroup__gubYy`,
	"lineItemList": `EstimatedTotal_lineItemList__VtVgD`,
	"lineItem": `EstimatedTotal_lineItem__WSssA`,
	"lineItemName": `EstimatedTotal_lineItemName__+KmyV`,
	"lineItemDetails": `EstimatedTotal_lineItemDetails__LXvJF`,
	"noLineItems": `EstimatedTotal_noLineItems__FoBq9`,
	"totalRow": `EstimatedTotal_totalRow__xAl94`,
	"instructionText": `EstimatedTotal_instructionText__KWObW`
};
export default ___CSS_LOADER_EXPORT___;
